import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components

import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import CheckList_TwoColumns from "reusables/TextFormats/CheckList_TwoColumns";

function Residential_Section2() {
  const titlesDescriptionsObj = {
    "Better Air Quality":
      "Regular cleaning removes dust, allergens, and dirt, improving indoor air quality and creating a fresher, healthier environment for your family.",
    "Reduced Stress":
      "A clean home means one less thing to worry about. Let us handle the upkeep so you can enjoy peace of mind and focus on what truly matters.",
    "Healthier Environment":
      "Consistent cleaning keeps bacteria and germs at bay, protecting your family from illnesses and fostering a safe, hygienic space.",
    "Enhanced Organization":
      "It’s easier to keep personal items and tasks in order when your home is clean and clutter-free, making daily life more manageable.",
    "Boosted Immune System":
      "Regularly eliminating dust and pathogens helps prevent immune suppression, keeping you and your loved ones healthier.",
    "More Time for Priorities":
      "With cleaning off your to-do list, you can spend more time on your family, hobbies, or personal goals, while we ensure your home remains spotless.",
  };
  return (
    <Container>
      <Grid container alignItems="center">
        <Grid item display={"flex"} flexDirection={"column"}>
          <Grid item>
            <SubTitleContents
              title="Why Regular Cleaning is Essential for Your Home?"
              contents="Maintaining a clean and organized home on a regular basis goes beyond aesthetics—it contributes to your overall well-being, reduces stress, and keeps your living space healthy and functional. Here’s why committing to regular cleaning is a must:"
            />
          </Grid>
          <Grid item>
            <CheckList_TwoColumns titlesDescriptionsObj={titlesDescriptionsObj} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Residential_Section2;
